// item 1: «Нет в списке» — псевдо-страна. Намеренно НЕ входит в COUNTRIES и в
// COUNTRY_TO_SHOP_LOCALE: из-за отсутствия локали ShopModal показывает попап
// «магазин в разработке», а shouldPulseShopIcon перестаёт пульсировать (getShopLocale
// вернёт null → hasRecommendation=false). Выбор персистится в localStorage.
export const COUNTRY_NOT_LISTED = "NOT_LISTED";

export const COUNTRIES = [
  { code: "RU", flag: "ru", nameKey: "countries.RU" },
  // Английская версия магазина (по алфавиту кода)
  { code: "DK", flag: "dk", nameKey: "countries.DK" },
  { code: "ES", flag: "es", nameKey: "countries.ES" },
  { code: "FI", flag: "fi", nameKey: "countries.FI" },
  { code: "FR", flag: "fr", nameKey: "countries.FR" },
  { code: "IT", flag: "it", nameKey: "countries.IT" },
  { code: "NL", flag: "nl", nameKey: "countries.NL" },
  { code: "NO", flag: "no", nameKey: "countries.NO" },
  { code: "SE", flag: "se", nameKey: "countries.SE" },
  // Немецкая версия магазина (по алфавиту кода)
  { code: "AT", flag: "at", nameKey: "countries.AT" },
  { code: "BE", flag: "be", nameKey: "countries.BE" },
  { code: "CH", flag: "ch", nameKey: "countries.CH" },
  { code: "DE", flag: "de", nameKey: "countries.DE" },
  { code: "LU", flag: "lu", nameKey: "countries.LU" },
];

export function findCountryByCode(code) {
  return COUNTRIES.find((c) => c.code === code) || null;
}
